import Vue from 'vue'
import router from '@/router/index.js'
import store from '@/store/index.js'
import axios from 'axios'
import App from './App.vue'
import vuetify from '@/plugins/vuetify' // path to vuetify export



axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.request.use(
    (config) => {
        let token = store.state.auth.token;

        if (token) {
            config.headers['Authorization'] = `Token ${token}`;
        }
        return config;
    },

    (error) => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    res => {
        if (res.status === 201) {
            store.commit('setMessage', {
                text: `Creation Successful`,
                type: 'success',
                alert: true
            })
        }

        if (res.config.method === 'patch') {
            store.commit('setMessage', {
                text: `Update Successful`,
                type: 'success',
                alert: true
            })
        }

        if (res.config.method === 'delete') {
            store.commit('setMessage', {
                text: `Successfully Deleted`,
                type: 'error',
                alert: true
            })
        }
        return res
    },
    err => {
        if (err.response.status === 400) {
            Object.keys(err.response.data).forEach(key => {
                store.commit('setMessage', {
                    text: `${err.response.data[`${key}`][0]}`,
                    type: 'error',
                    alert: true
                })
            })

            throw err;
        }
        if (err.response.status === 404 && err.response.data === 'Login Incorrect') {
            store.commit('setMessage', {
                text: err.response.data,
                type: 'error',
                alert: true
            })
            throw err;
        }
        throw err;
    }
);


Vue.config.productionTip = false

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App),
}).$mount('#app')
